import type { TFunction } from 'i18next';

import yup from '../../../shared/validation';

export function getProgramValidation(t: TFunction) {
  return yup.object({
    title: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.nameRequired')),
  });
}
